export default '/scores';
